export const organization = {
  '@context': 'http://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': 'https://www.coches.net/#website',
      url: 'https://www.coches.net/',
      name: 'coches.net',
      description: 'Portal de coches nuevos y coches de ocasión',
      inLanguage: 'es',
      publisher: {
        '@id': 'https://www.coches.net/#organization'
      }
    },
    {
      '@context': 'http://schema.org',
      '@type': 'Organization',
      '@id': 'https://www.coches.net/#organization',
      url: 'https://www.coches.net/',
      name: 'coches.net',
      legalName: 'Adevinta Motor S.L.U.',
      foundingDate: '1999',
      description: 'Portal líder de motor en España para comprar y vender coches nuevos y de ocasión',
      taxID: 'B-70677158',
      logo: {
        '@type': 'ImageObject',
        '@id': 'https://www.coches.net/#logo',
        url: 'https://s.ccdn.es/images/coches/icons/logo-square-rounded-512x512.png',
        height: 512,
        width: 512,
        caption: 'coches.net'
      },
      image: {
        '@id': 'https://www.coches.net/#logo'
      },
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'C/Hernani, 59, 1a planta',
        addressLocality: 'Madrid',
        postalCode: '28020',
        addressCountry: 'ES'
      },
      sameAs: [
        'https://www.youtube.com/user/cochesnet',
        'https://www.facebook.com/Coches.net',
        'https://x.com/Cochesnet',
        'https://www.instagram.com/cochesnetoficial',
        'https://www.tiktok.com/@coches.net',
        'https://es.linkedin.com/company/coches-net'
      ],
      parentOrganization: {
        '@type': 'Organization',
        '@id': 'https://www.adevinta.com/#organization',
        name: 'Adevinta',
        url: 'https://www.adevinta.com/',
        logo: {
          '@type': 'ImageObject',
          '@id': 'https://www.adevinta.com/#logo',
          inLanguage: 'en-US',
          url: 'https://s.ccdn.es/images/common/logos/adevinta-logo.svg',
          contentUrl: 'https://s.ccdn.es/images/common/logos/adevinta-logo.svg',
          width: 430,
          height: 96,
          caption: 'Adevinta'
        },
        image: {
          '@id': 'https://www.adevinta.com/#logo'
        }
      }
    }
  ]
}
